export const howBodyCodingWorks = {
    heading: "How Body Coding Works",
    content: [
        {
            title: 'Tapping into the Subconscious Mind',
            description: 'Body Coding connects with the subconscious mind — the body\'s internal guidance system that knows exactly where imbalances exist and what is required to restore harmony.'
        },
        {
            title: 'Identifying Imbalances & Physical Needs',
            description: 'Through focused intention and intuitive testing, Body Coding pinpoints trapped emotions, energetic blockages, and physical needs like nutrients or minerals that the body requires for optimal health.'
        },
        {
            title: 'Releasing Energy Blocks',
            description: 'Once identified, these trapped energies are gently released, restoring harmony and balance throughout the body\'s energy systems.'
        },
        {
            title: 'Restoring Communication',
            description: 'By clearing interference and energetic distortion, Body Coding helps re-establish natural communication between the body, mind, and spirit — allowing energy to flow freely again.'
        },
        {
            title: 'Promoting Self-Healing',
            description: 'As the body\'s energy realigns, its innate ability to heal itself is reactivated, supporting deep physical, emotional, and spiritual healing.'
        },
        {
            title: 'Supporting Transformation',
            description: 'With each release, old energetic patterns dissolve, creating space for new, positive frequencies that attract love, health, and abundance.'
        }
    ],
}